import { BrewGuideCardProps } from "@bluebottlecoffee/design-system/dist/BrewGuideCard/BrewGuideCard";
import { brewGuidePage } from "../link-builders";
import {
  BrewGuide,
  BrewGuideCard,
  BrewGuidesPage as BrewGuidesPageSchema,
} from "../sanity-schema";
import { ImageType, toImageProps } from "./image";

export type BrewGuideCardSchemaWithSlug = Omit<BrewGuideCard, "brewGuide"> & {
  brewGuide: BrewGuide;
};

export type BrewGuidesPageSchemaWithGuide = Omit<
  BrewGuidesPageSchema,
  "guides"
> & {
  guides: BrewGuideCardSchemaWithSlug[];
};

export function toBrewGuideCardProps(
  data: BrewGuideCardSchemaWithSlug,
  lang: string,
  region: string,
): BrewGuideCardProps {
  const circleDetailPlaceholderImage =
    "/ar_1:1,b_rgb:ffffff,bo_0px_solid_rgb:ffffff,c_crop,fl_clip,g_center,h_1000,r_1000,w_1000/v1630525715/roasted-beans_wfou4v.png";

  const detailImage: ImageType | undefined = data.image;

  const detailImageSource: string = detailImage
    ? toImageProps(detailImage, lang).src
    : circleDetailPlaceholderImage;

  return {
    notes: data.notes?.[lang],
    subtitle: data.subtitle?.[lang],
    detail: {
      isCircleCrop: data?.isCircleCrop,
      title: data?.title[lang] ?? "",
      infoLine1: data?.infoLine1?.[lang] ?? "",
      infoLine2: data?.infoLine2?.[lang] ?? "",
      image: {
        src: detailImageSource,
        altText: data?.image?.altText?.[lang] ?? "",
      },
    },
    cta: {
      activeText: data.buttonText?.[lang] ?? "View Guide",
      link: brewGuidePage({ region, lang, slug: data.brewGuide.slug.current }),
    },
  };
}
